<template>
    <div :class="` animated ${showServiceForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`">
        <FormSection :application-id="application" :showBackground="false">
            <template v-if="isLoading" #content>
                <div class="p-5 d-flex flex-column text-center text-primary">
                    <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
                    <div class="big-text mt-1">
                        <b>Save Service Location In Progress...</b>
                    </div>
                </div>
            </template>
            <template #content v-if="!isLoading">
                <div class="w-100 row no-gutters mb-2 p-3">
                    <div class="col-12 col-lg-4 pe-lg-2 form-group d-flex flex-column">
                        <label for="facility-name"> Facility Name </label>
                        <TypeaheadInput
                            id="facility-name"
                            :getData="getVendorList"
                            :value="selectedFacility"
                            v-on:valueChanged="updateFacility"
                            :init-value="selectedFacility"
                            placeholder="Start Typing..."
                        ></TypeaheadInput>
                        <a type="button" class="dashboard-menu-vue my-2" @click="handleDirectionToFacility()">
                            <span class="text-center">Add Facility </span>
                        </a>
                    </div>
                    <div class="col-12 col-lg-4 pe-lg-2 form-group">
                        <label>
                            Country
                            <span class="text-danger">*</span>
                        </label>
                        <CountryTypeahead
                            :updateSelectedCountry="updateSelectedCountry"
                            :prefill-country="service.country"
                            :disabled="selectedFacility ? true : false"
                            v-on:blurredInput="v$.service.country.$touch()"
                        >
                        </CountryTypeahead>
                    </div>
                    <div class="w-100"></div>
                    <div class="col-12 col-lg-4 pe-lg-2 form-group">
                        <label for="referral-service-line-1">
                            Address Line 1
                            <span class="text-danger">*</span>
                        </label>

                        <PlacesAutocomplete
                            v-model:street="service.addressLine1"
                            v-model:city="service.city"
                            v-model:state="service.state"
                            v-model:zip="service.zipCode"
                            v-model:county="service.county"
                            v-model:country="autoCompleteCountry"
                            :places-changed-call-back="placesChangedCallBack"
                            v-on:blurredInput="v$.service.addressLine1.$touch()"
                            :disabled="selectedFacility ? true : false"
                        >
                        </PlacesAutocomplete>
                    </div>
                    <div class="col-12 col-lg-4 pe-lg-2 form-group">
                        <label for="referral-service-line-2"> Address Line 2 </label>
                        <input
                            id="referral-service-line-2"
                            class="form-control"
                            maxlength="50"
                            type="text"
                            placeholder="Enter Address Line 2"
                            v-model="service.addressLine2"
                            :disabled="selectedFacility ? true : false"
                        />
                    </div>
                    <div class="w-100"></div>

                    <div class="col-12 col-lg-2 pe-lg-2 form-group">
                        <label for="referral-city">
                            City
                            <span class="text-danger">*</span>
                        </label>
                        <input
                            id="referral-city"
                            class="form-control"
                            maxlength="50"
                            type="text"
                            placeholder="Enter City"
                            v-model="service.city"
                            :disabled="selectedFacility ? true : false"
                            @blur="v$.service.city.$touch()"
                        />
                    </div>
                    <div class="col-12 col-lg-2 pe-lg-2 form-group">
                        <label>
                            {{ isUnitedStates ? "State" : "State / Province / Territory" }}
                            <span class="text-danger">*</span>
                        </label>
                        <StateTypeahead
                            v-model:selected-state="selectedState"
                            v-model:prefill-state="service.state"
                            :disabled="selectedFacility ? true : false"
                            v-if="isUnitedStates"
                            v-on:updateSelectedState="updateSelectedState"
                        >
                        </StateTypeahead>
                        <input
                            class="form-control"
                            maxlength="50"
                            type="text"
                            v-model="service.state"
                            placeholder="Enter State / Province / Territory"
                            :disabled="selectedFacility ? true : false"
                            @blur="v$.service.state.$touch()"
                            v-else
                        />
                    </div>
                    <div class="col-12 col-lg-2 pe-lg-2 form-group">
                        <label for="referral-zip">
                            {{ isUnitedStates ? "ZIP" : "Postal Code" }}
                            <span class="text-danger">*</span>
                        </label>
                        <input
                            id="referral-zip"
                            class="form-control"
                            maxlength="50"
                            type="text"
                            v-model="service.zipCode"
                            placeholder="Enter Postal Code"
                            :disabled="selectedFacility ? true : false"
                            @blur="v$.service.zipCode.$touch()"
                        />
                    </div>
                    <div class="col-12 col-lg-2 pe-lg-2 form-group">
                        <label for="referral-county"> County <span class="text-danger">*</span></label>
                        <input
                            id="referral-county"
                            class="form-control"
                            maxlength="50"
                            type="text"
                            placeholder="Enter County"
                            v-model="service.county"
                            :disabled="selectedFacility ? true : false"
                        />
                    </div>
                    <div class="w-100"></div>
                    <div class="form-group col-3">
                        <label for="service_location">
                            Select Location
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <select
                            id="Referral_Service_Location"
                            name="service_location"
                            class="form-select"
                            v-model="service.Code"
                        >
                            <option :value="null">Select Location</option>
                            <option
                                v-for="serviceLocation of filteredServiceLocations"
                                :value="serviceLocation.Value"
                                :key="serviceLocation.Value"
                                :disabled="serviceLocation.Value === null"
                            >
                                {{ serviceLocation.Name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-lg-3 pe-lg-2">
                        <label for="date">
                            Date
                            <span class="text-danger">*</span>
                        </label>
                        <DatePicker :getDate="updateDate">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="date"
                                    type="text"
                                    class="form-control"
                                    placeholder="MM/DD/YYYY"
                                    autocomplete="off"
                                    :value="formatDate(service.Start)"
                                    @change="handleDateChange"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>
                    <div class="form-group col-12 col-lg-3 pe-lg-2">
                        <label for="DOB">
                            Time
                            <span class="text-danger">*</span>
                        </label>
                        <TimePicker class="flex-fill ms-1" @update-props="changeStartTime">
                            <input
                                id="travel-start-time"
                                type="text"
                                class="form-control"
                                autocomplete="off"
                                :value="service.StartTime"
                            />
                        </TimePicker>
                    </div>
                    <div class="form-group col-12 mt-4 d-flex justify-content-center">
                        <button type="button" class="btn btn-primary me-2 mb-2" @click="handleSave">
                            {{ isEdit ? "Update" : "Add" }} Service Location
                        </button>
                        <button type="button" class="btn btn-outline-primary mb-2" @click="closeServiceForm">
                            Cancel
                        </button>
                    </div>
                </div>
            </template>
        </FormSection>
    </div>
</template>

<script src="./AddServiceLocationForm.ts"></script>
